
var SAMPLE_REASON = '予約サイトより同時にゲストの宿泊が入ったため、申請に失敗しました。\n恐れ入りますが、別日の申請をお願いいたします。';

export default {
  name: 'stay-review',
  props: {
    value: { type: Boolean, default: false },
    stay: { type: Object, default: null },
    items: { type: Array, default: function () { return []; } },
    landlordId: { type: [Number, String], default: null },
    live: { type: Boolean, default: true }
  },
  data: function () {
    return {
      reason: '',
      reasonHint: '予約サイトより同時にゲストの宿泊が入ったため、申請に失敗しました。\n恐れ入りますが、別日の申請をお願いいたします。',
      busy: false,
      loading: false,
      localItems: [],
      localStay: null
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    activeStay: function () {
      return this.localStay || this.stay || null;
    },
    reviewItems: function () {
      if (this.usesLandlord || !this.live) return this.localItems;
      if (this.items && this.items.length) return this.items;
      if (this.stay) return [this.stay];
      return [];
    },
    usesLandlord: function () {
      return this.live && this.landlordId !== null && this.landlordId !== '' && Number(this.landlordId) > 0;
    },
    landlordLabel: function () {
      var s = this.activeStay;
      if (!s) return '○○';
      if (s.landlord_name) return s.landlord_name;
      var l = s.landlord;
      if (l) {
        if (l.name) return l.name;
        return (l.lastname || '') + (l.firstname || '');
      }
      return '○○';
    },
    roomLabel: function () {
      var s = this.activeStay;
      if (!s) return '○○邸';
      if (s.room_name) return s.room_name;
      if (s.room && s.room.name) return s.room.name;
      return '○○邸';
    },
    isCancel: function () {
      var s = this.activeStay;
      if (!s) return false;
      return s.mode === 'cancel' || s.kind === 'cancel' || s.status === 'cancelled';
    },
    canAct: function () {
      var s = this.activeStay;
      if (!s || this.busy || this.isCancel) return false;
      return !s.status || s.status === 'pending';
    },
    dateLabel: function () {
      var s = this.activeStay;
      var a = this.parseStayDate(s);
      if (!a) return '';
      var head = a.month + '月' + a.day + '日';
      if (!s || !s.date_to) return head;
      var m = String(s.date_to).match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (!m) return head;
      var bm = parseInt(m[2], 10);
      var bd = parseInt(m[3], 10);
      if (bm === a.month && bd === a.day) return head;
      if (bm === a.month) return head + '〜' + bd + '日';
      return head + '〜' + bm + '月' + bd + '日';
    }
  },
  watch: {
    value: function (opened) {
      if (!opened) return;
      this.busy = false;
      if (!this.live) {
        this.localItems = this.mockItems();
        this.localStay = this.localItems[0] || null;
        this.syncReason();
        return;
      }
      if (this.usesLandlord) {
        this.loadForLandlord();
        return;
      }
      this.localStay = this.stay || this.reviewItems[0] || null;
      this.syncReason();
    },
    stay: function (row) {
      if (this.usesLandlord || !this.value || !row) return;
      this.localStay = row;
      this.syncReason();
    },
    landlordId: function () {
      if (this.value && this.usesLandlord) this.loadForLandlord();
    }
  },
  created: function () {
    if (!this.live) this.reason = SAMPLE_REASON;
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastMock: function () {
      this.toast('mock：未接线');
    },
    toastFail: function (res) {
      var status = res && res.data ? res.data.status : null;
      var msg = res && res.data ? res.data.msg : '';
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else if (msg) this.toast(msg);
      else this.toast('失敗しました');
    },
    mockItems: function () {
      return [
        { id: 'mock-1', stay_date: '2026-06-23', date_to: '2026-06-28', status: 'pending', landlord_name: '○○', room_name: '○○邸' },
        { id: 'mock-2', stay_date: '2026-06-29', date_to: '2026-06-30', status: 'pending', landlord_name: '○○', room_name: '○○邸' },
        { id: 'mock-3', stay_date: '2026-07-20', date_to: '2026-07-22', status: 'approved', landlord_name: '○○', room_name: '○○邸' },
        { id: 'mock-4', stay_date: '2026-07-22', date_to: '2026-07-28', status: 'approved', landlord_name: '○○', room_name: '○○邸' }
      ];
    },
    parseStayDate: function (stay) {
      var s = stay || this.activeStay;
      if (!s || !s.stay_date) return null;
      var m = String(s.stay_date).match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (!m) return null;
      return { month: parseInt(m[2], 10), day: parseInt(m[3], 10) };
    },
    shortDate: function (iso) {
      var m = String(iso || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (!m) return '';
      return parseInt(m[2], 10) + '/' + parseInt(m[3], 10);
    },
    rangeLabel: function (row) {
      if (!row) return '';
      var a = this.shortDate(row.stay_date);
      var b = this.shortDate(row.date_to || row.stay_date);
      if (!a) return '';
      if (!b || b === a) return a;
      return a + '-' + b;
    },
    isPending: function (row) {
      return !!(row && (!row.status || row.status === 'pending'));
    },
    badgeLabel: function (row) {
      if (!row) return '';
      if (row.mode === 'cancel' || row.kind === 'cancel' || row.status === 'cancelled') return '取消';
      if (this.isPending(row)) return '処理待ち';
      return '処理済み';
    },
    badgeClass: function (row) {
      if (row && (row.mode === 'cancel' || row.kind === 'cancel' || row.status === 'cancelled')) return 'is-cancel';
      return this.isPending(row) ? 'is-pending' : 'is-done';
    },
    isActive: function (row) {
      var s = this.activeStay;
      if (!row || !s) return false;
      if (row === s) return true;
      return row.id != null && s.id != null && String(row.id) === String(s.id);
    },
    syncReason: function () {
      if (!this.live) {
        this.reason = SAMPLE_REASON;
        return;
      }
      var s = this.activeStay;
      this.reason = s && s.reject_reason ? s.reject_reason : '';
    },
    loadForLandlord: function (keepId, skipId) {
      var t = this;
      var id = Number(t.landlordId);
      if (!id) return;
      var keep = keepId;
      if (keep == null && skipId == null) keep = t.localStay && t.localStay.id;
      t.loading = true;
      axios.get('ownerStay', { params: { landlord_id: id, status: 'all' } }).then(function (res) {
        t.loading = false;
        if (!t.value || Number(t.landlordId) !== id) return;
        if (res.data.status != 1) {
          t.toastFail(res);
          return;
        }
        var items = (res.data.options && res.data.options.items) || [];
        t.localItems = items;
        var found = null;
        if (keep != null) {
          items.forEach(function (row) {
            if (!found && String(row.id) === String(keep)) found = row;
          });
        }
        if (!found) found = t.nextPending(items, skipId);
        if (!found && skipId == null) found = items[0] || null;
        if (!found) {
          if (skipId != null) t.close();
          else {
            t.localStay = null;
            t.syncReason();
          }
          return;
        }
        t.localStay = found;
        t.syncReason();
        t.$nextTick(function () {
          t.focusActiveRow();
        });
      }).catch(function () {
        t.loading = false;
        if (t.value) t.toast('通信に失敗しました');
      });
    },
    pickStay: function (row) {
      this.localStay = row;
      this.syncReason();
      this.$emit('pick', row);
    },
    close: function () {
      this.$emit('input', false);
    },
    markReviewed: function (id, kind) {
      if (id == null) return;
      var status = kind === 'rejected' ? 'rejected' : 'approved';
      (this.localItems || []).concat(this.items || []).forEach(function (row) {
        if (row && String(row.id) === String(id)) row.status = status;
      });
    },
    nextPending: function (items, reviewedId) {
      items = items || [];
      var start = 0;
      var i;
      if (reviewedId != null) {
        for (i = 0; i < items.length; i++) {
          if (items[i] && String(items[i].id) === String(reviewedId)) start = i + 1;
        }
      }
      for (i = start; i < items.length; i++) {
        if (this.isPending(items[i]) && String(items[i].id) !== String(reviewedId)) return items[i];
      }
      for (i = 0; i < start; i++) {
        if (this.isPending(items[i]) && String(items[i].id) !== String(reviewedId)) return items[i];
      }
      return null;
    },
    focusActiveRow: function () {
      var root = this.$el;
      if (!root || !root.querySelector) return;
      var el = root.querySelector('.owner-stay-review__item.is-active');
      if (!el) return;
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      if (el.focus) el.focus();
    },
    focusNextOrClose: function (reviewedId) {
      var next = this.nextPending(this.reviewItems, reviewedId);
      if (!next) {
        this.close();
        return;
      }
      this.localStay = next;
      this.syncReason();
      var t = this;
      this.$nextTick(function () {
        t.focusActiveRow();
      });
    },
    finish: function (kind) {
      var reviewedId = this.activeStay && this.activeStay.id;
      this.markReviewed(reviewedId, kind);
      this.focusNextOrClose(reviewedId);
      this.$emit('done', kind);
      if (this.value && this.usesLandlord) this.loadForLandlord(null, reviewedId);
    },
    onApprove: function () {
      if (this.isCancel) {
        this.toast('取消申請は現在確認のみです');
        return;
      }
      if (!this.live) {
        this.finish('approved');
        this.toastMock();
        return;
      }
      var id = this.activeStay && this.activeStay.id;
      if (!id) {
        this.toast('申請が指定されていません');
        return;
      }
      if (this.busy) return;
      var t = this;
      t.busy = true;
      axios.post('ownerStay/approve/' + id).then(function (res) {
        t.busy = false;
        if (res.data.status != 1) {
          t.toastFail(res);
          return;
        }
        t.finish('approved');
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    onReject: function () {
      if (this.isCancel) {
        this.toast('取消申請は現在確認のみです');
        return;
      }
      var reason = (this.reason || '').trim();
      if (!reason) {
        this.toast('理由を記入してください');
        return;
      }
      if (!this.live) {
        this.finish('rejected');
        this.toastMock();
        return;
      }
      var id = this.activeStay && this.activeStay.id;
      if (!id) {
        this.toast('申請が指定されていません');
        return;
      }
      if (this.busy) return;
      var t = this;
      t.busy = true;
      axios.post('ownerStay/reject/' + id, { reason: reason }).then(function (res) {
        t.busy = false;
        if (res.data.status != 1) {
          t.toastFail(res);
          return;
        }
        t.finish('rejected');
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    }
  }
};
